// extracted by mini-css-extract-plugin
export default {"trackingParagraph":"TrackingInfo_trackingParagraph__JC49W","trackingParamSpan":"TrackingInfo_trackingParamSpan__8zkcN"};